const Lang = require('lang');

function CreateOffice() {
  const buttons = document.querySelectorAll('[data-departamento]');
  const modal = $('#criar-cargo-modal');

  [].forEach.call(buttons, function(button) {
    button.addEventListener('click', function(e) {
      const target = e.currentTarget;
      const url = route(
        'app.settings.departamentos.show', {
          departamento: target.dataset.departamento
        }
      );

      nifty.body.overlay('show');

      $.get(url, function(departamento) {
        modal.find('.modal-title')
          .html(Lang.get('js/src/functions/CreateOffice.create_new_role') + ' "<strong>' + departamento.descricao + '</strong>"')
        modal.find('#idDepartamento').val(departamento.id);
        nifty.body.overlay('hide');
        modal.modal('show');
      });
    });
  });

}

module.exports = {
  url: route('app.settings.departamentos.index'),
  init: CreateOffice
}

